import React from 'react'
import ReactDOM from 'react-dom/client'
import { ThemeProvider, createTheme } from '@mui/material'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { SessionInput } from './components/SessionInput'
import { SessionView } from './pages/SessionView'
import './index.css'

const theme = createTheme({
  palette: {
    primary: {
      main: '#40C057',
      dark: '#37A84D',
      light: '#E8F5E9',
    },
    background: {
      default: '#F8FAFC',
    },
    grey: {
      100: '#F1F5F9',
      200: '#E2E8F0',
    },
  },
  typography: {
    fontFamily: 'Inter, system-ui, Avenir, Helvetica, Arial, sans-serif',
    h5: {
      fontWeight: 700,
    },
    body2: {
      fontSize: '0.875rem',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 12,
        },
      },
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          <Route path="/" element={<SessionInput />} />
          <Route path="/view/:sessionId" element={<SessionView />} />
        </Routes>
      </Router>
    </ThemeProvider>
  </React.StrictMode>
)
